export enum ActivitySearchCodeType {
  CityCode = 'CityCode',
  Activity = 'Activity',
}
